import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InlineSelect, MenuItem } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { getEditDropdownRecipientTypeText, getRecipientTypesText, handleSetRecipientTypes, notificationSettingsTextsPath } from '../../../NotificationSettings.utils';
import { GetRecipientsDropdownTID } from './RecipientsDropdown.testIds';
export const RecipientsDropdown = (param)=>{
    let { notificationName, recipientTypes, recipientTypeOptions, error, onChange } = param;
    const { RecipientsDropdownTestIds: testIds } = useMemo(()=>GetRecipientsDropdownTID(), []);
    const featureFlags = useFeatureFlags();
    const { t: notifTexts } = useLocaleKeys(notificationSettingsTextsPath);
    const { t: contentTexts } = useLocaleKeys('pages.notificationSettings.contentCustomization');
    const optionLabels = getEditDropdownRecipientTypeText({
        notificationName,
        texts: notifTexts
    });
    const handleChange = (next)=>{
        const nextTypes = next;
        const added = nextTypes.find((type)=>!recipientTypes.includes(type));
        const removed = recipientTypes.find((type)=>!nextTypes.includes(type));
        const newType = added !== null && added !== void 0 ? added : removed;
        if (newType == null) return;
        handleSetRecipientTypes({
            newType,
            newRecipientTypes: nextTypes,
            setRecipientTypes: onChange
        });
    };
    return /*#__PURE__*/ _jsx(InlineSelect, {
        skin: "primary",
        multiple: true,
        value: recipientTypes,
        onChange: handleChange,
        error: error,
        placeholder: contentTexts.notifyRowLabel(),
        renderValue: (selected)=>{
            const selectedSet = new Set(selected);
            const orderedTypes = recipientTypeOptions.filter((type)=>selectedSet.has(type));
            return getRecipientTypesText({
                recipientTypes: orderedTypes,
                notificationName,
                texts: notifTexts,
                featureFlags
            }).join(', ');
        },
        bi: {
            name: 'notify_recipients'
        },
        testId: testIds.Trigger(),
        children: recipientTypeOptions.map((type)=>/*#__PURE__*/ _jsx(MenuItem, {
                value: type,
                testId: testIds.Option(type),
                children: optionLabels[type]
            }, type))
    });
};
